
import LoginPage from "@/pages/LoginPage.vue";
import SendMessagePage from "@/pages/SendMessagePage.vue";
import showListDichVuCong from "@/pages/ShowListDichVuCong.vue";

import { useStore } from 'vuex'
import { computed } from 'vue'
import {useRouter} from "vue-router";

export default {
  components: {
    LoginPage,
    showListDichVuCong
  },
  setup(){
    const store = useStore();
    const isLoggedIn = computed(() => !!store.state.token);
    const router = useRouter();

    console.log("@@@@############## debbug Home isLoggedIn....." + JSON.stringify(isLoggedIn));
    // router.push({
    //   name: 'sendmessage'AddEvent.vue
    // });
    return {
      isLoggedIn
    }
  }
}
